import React, { FC } from 'react';

interface PropTypes{
  className?: string
}
export const IconRightDiff : FC<PropTypes> = ({className}) =>  <i className={`fas fa-chevron-circle-left ${className ? className : "ms-2"}`} />
